import { render } from "./YellowAddMeetingRoom.vue?vue&type=template&id=45abe648"
import script from "./YellowAddMeetingRoom.vue?vue&type=script&lang=js"
export * from "./YellowAddMeetingRoom.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__